import Category from "../Category";
import MenuItemBuilder from "../MenuItemBuilder";
import {addOnOptions} from "../AddOnOptions";

export default new Category('Seafood', 'images/categories/seafood.jpg')
    .setDescription('Served w/ White Rice')
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Lobster Sauce', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Broccoli', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Mixed Vegetable', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Cashew Nuts', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Curry Sauce', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Garlic Sauce', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Hunan Shrimp', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Szechuan Shrimp', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Kung Pao Shrimp', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Shrimp w/ Scallops', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Sweet & Sour Shrimp', 9.95)
        .setServingOptions(1).setAddOns(...addOnOptions).build())
    .addMenuItem(new MenuItemBuilder('Hot & Spicy Shrimp', 9.95)
        .setSpicy(true).setServingOptions(1).setAddOns(...addOnOptions).build())